export { default as InfoIcon } from "./InfoIcon";
